webpackJsonp([262546004982204],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _RowDetail = __webpack_require__(116);
	
	var _RowDetail2 = _interopRequireDefault(_RowDetail);
	
	var _wsuPreview_ = __webpack_require__(481);
	
	var _wsuPreview_2 = _interopRequireDefault(_wsuPreview_);
	
	var _wsuScan = __webpack_require__(482);
	
	var _wsuScan2 = _interopRequireDefault(_wsuScan);
	
	var _wsuFlowMap = __webpack_require__(480);
	
	var _wsuFlowMap2 = _interopRequireDefault(_wsuFlowMap);
	
	var _wsuSlackWhite = __webpack_require__(483);
	
	var _wsuSlackWhite2 = _interopRequireDefault(_wsuSlackWhite);
	
	var _wsuUi = __webpack_require__(484);
	
	var _wsuUi2 = _interopRequireDefault(_wsuUi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mobile = void 0,
	    prototype = void 0,
	    report = void 0;
	
	mobile = 'https://s3-ap-southeast-2.amazonaws.com/nataliejohnson/wsu-iphone-scenes.mp4';
	prototype = 'https://s3-ap-southeast-2.amazonaws.com/nataliejohnson/wsu-flashlight-prototype.mp4';
	report = 'https://s3-ap-southeast-2.amazonaws.com/nataliejohnson/wsu-report.mp4';
	
	var Wsu = function Wsu() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_ProjectHeader2.default, {
	      heading: 'An interactive library tour experience',
	      client: 'Western Sydney University Library'
	    }),
	    _react2.default.createElement(_SingleImage2.default, { img: _wsuPreview_2.default, margin: true }),
	    _react2.default.createElement(
	      _ProjectDetails2.default,
	      {
	        client: 'Western Sydney University Library',
	        duration: '9 weeks',
	        role: 'User experience designer, front-end developer & project manager',
	        deliverables: 'Prototyping, user flows, wireframes, user interface design, front-end development',
	        credit1: _react2.default.createElement(_RowDetail2.default, { title: 'Illustration', value: _react2.default.createElement(
	            _AHref2.default,
	            { url: 'http://cargocollective.com/kallieennever' },
	            'Kallie Ennever'
	          ) }),
	        credit2: _react2.default.createElement(_RowDetail2.default, { title: 'Development', value: _react2.default.createElement(
	            _AHref2.default,
	            { url: 'http://fractallambda.com/' },
	            'Brice Fernandes'
	          ) })
	      },
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'The challenge'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In 2016, Western Sydney University (WSU) Library approached me wanting to create a web app for their 2017 Orientation Weeks. They wanted to create a novel and self-guided way for new students to interact with the library\u2019s services, while engaging with some of the traditional learning outcomes of a traditional library tour, and envisioned an escape room-style experience inspired by cult-tv show Stranger Things.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To help bring the idea to life, I bought on board illustrator ',
	        _react2.default.createElement(
	          _AHref2.default,
	          { url: 'http://cargocollective.com/kallieennever' },
	          'Kallie Ennever'
	        ),
	        ' and software engineer ',
	        _react2.default.createElement(
	          _AHref2.default,
	          { url: 'http://fractallambda.com/' },
	          'Brice Fernandes'
	        ),
	        '. Working closely with the team at WSU Library, we developed \u2018Portal Panic\u2019, an app that told the story of \u2018Six\u2019, a research student who had disappeared into a portal and needed to be found. Students used the app to explore the library, pick up clues, solve puzzles and unlock levels, rescuing Six and closing all the portals forever.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          _AHref2.default,
	          { url: 'http://wsu-library-escape.s3-website-ap-southeast-2.amazonaws.com/' },
	          'Take the tour'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'video',
	        { autoPlay: true, loop: true, muted: true },
	        _react2.default.createElement('source', { type: 'video/mp4', src: mobile })
	      )
	    ),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Gathering requirements'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To begin, we conducted on-site walkthroughs of the proposed library tour activities at both WSU\u2019s Hawkesbury and Parramatta campuses. I then worked to translate the entire, end-to-end experience into a flow map, outlining how the physical and digital touchpoints of the tour would interact.'
	      )
	    ),
	    _react2.default.createElement(_SingleImage2.default, { img: _wsuScan2.default, small: true }),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Using the flow map as our foundation, Kallie, Brice and I worked together to specify the more detailed interactions of the app. We thought about how we might tell a story, embed principles of gamification, and bring in elements of the \u2018upside down\u2019 into the app.'
	      )
	    ),
	    _react2.default.createElement(_SingleImage2.default, { img: _wsuFlowMap2.default, caption: 'I worked with Kallie and Brice to create an end-to-end map of the entire experience, which became a trailing document and was used throughout the project.' }),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Prototyping into production'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'With only 6 weeks to deliver the final \u2018Portal Panic\u2019 web application, we decided to develop a prototype that would evolve into the final, fully functional application. To keep the development side of things simple, Brice built the app as a single page jQuery application with a Firebase backend.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Over the course of the project, Kallie, Brice and I worked collaboratively over Skype and Slack. We discussed ideas often by designing them directly into the browser \u2013 with Kallie creating rough mockups and then sending them through to Brice, who would then quickly pull together a working interaction for us all to review and expand upon.'
	      )
	    ),
	    _react2.default.createElement(_SingleImage2.default, { img: _wsuSlackWhite2.default }),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Test & refine'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To meet the project\u2019s tight timelines, we worked in weekly sprints. At the end of each week, we would deployed the working prototype and would send through the URL to the team at WSU Library.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Alongside the prototype, we also delivered a screencast explaining the features, known bugs and future improvements that would be made in the following week\u2019s release. The team at WSU Library would then test the prototype and subsequently feedback on changes, ideas, bugs and usability issues the next day over email and Skype.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'small-image' },
	      _react2.default.createElement(
	        'video',
	        { autoPlay: true, loop: true, muted: true },
	        _react2.default.createElement('source', { type: 'video/mp4', src: prototype })
	      ),
	      _react2.default.createElement(
	        'figcaption',
	        null,
	        'An early prototype of the flashlight puzzle, demonstrated in one of our weekly screencasts.'
	      )
	    ),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'My primary role at this phase was to make sure that we, as a team, met all the requirements and changes that were fed back from WSU Library. I also performed front-end development and made UI refinements, working closely with Kallie to create a cohesive visual language and ensure consistent interaction patterns throughout the app.'
	      )
	    ),
	    _react2.default.createElement(_SingleImage2.default, { img: _wsuUi2.default, margin: true, caption: 'I worked closely with Kallie to design a cosistent UI system well matched to her illustrations. We all fell in love with our font choice \u2013 Eskell Display from Letters from Sweden.' }),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Track & measure'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'WSU Library project managers also required a way to track and report on individual users\u2019 activity in the app. During the final week of the project, Brice and I worked together to build a custom analytics report that provided insights into user activity, behaviour and engagement within the app. The custom report page also provides WSU Library with a way to download raw user data to use in their own reports. '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner' },
	      _react2.default.createElement(
	        'video',
	        { autoPlay: true, loop: true, muted: true },
	        _react2.default.createElement('source', { type: 'video/mp4', src: report })
	      ),
	      _react2.default.createElement(
	        'figcaption',
	        null,
	        'The working version of the custom analytics report page, before data binding (fake figures marked in red).'
	      )
	    ),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Launch & impact'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In just 9 weeks, we designed, developed and delivered a fully functional application with its own analytics portal. The final result is a novel library tour experience that lets WSU Library onboard new students, wherever and whenever they would like. '
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Portal Panic launched across all six of WSU\u2019s campus libraries during orientation weeks in February 2017. The app received 266 unique registrations and garnered positive user feedback.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Going forward, WSU Library has recognised Portal Panic app as a viable alternative to traditional library tours, and has continued the use of the app throughout 2017 and into 2018.'
	      )
	    ),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        { className: 'h6' },
	        'Ongoing improvements'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'As part of our handover, Brice taught the team at WSU Library how to perform basic development tasks, including HTML editing, version control and deployment.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'In response to insights from the analytics and student feedback, WSU Library has since been able to build on this app over time. During 2017, the team at WSU Library updated and deployed various iterations of the app, and continues to do so into 2018.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'bg bg-grey' },
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Things we learned'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We were really happy with the way the app turned out, and even more so with the way we were able to work quickly as a team to collaboratively build and evolve the prototype. Here are a few things we learned along the way:'
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          'Show, don\'t tell'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Working virtually with a client can have its limitations. Screencasts were key in facilitating a shared understanding of the project, as they enabled us to have constant conversations with our client.'
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          'Clients can code'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Handing over the code was just the beginning. By empowering the client to code, we facilitated a budget-friendly way aligned with the iterative nature of web application development today, as well as ensuring it\u2019s continued use throughout 2017, and into 2018.'
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          'Fast has a quality all of its own'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'With Kallie and I living in opposite sides of Sydney, and Brice in the UK, we relied heavily on digital collaboration tools such as Slack, Skype, Trello, Floobits (with Atom), Dropbox and GitHub. These tools allowed us to work together virtually in highly collaborative ways \u2013 ways even more effective than sitting next to each other \u2013 and were essential in helping us evolve our ideas at a rapid pace.'
	        ),
	        _react2.default.createElement(
	          'h5',
	          null,
	          'The time difference between Australia and the UK also worked largely in our favour, allowing Brice and I to work in a continuous, 24-hour development cycle when required.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _TextBlock2.default,
	      null,
	      _react2.default.createElement('p', null)
	    )
	  );
	};
	
	exports.default = Wsu;
	module.exports = exports['default'];

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-flow-map.18bffcf6.jpg";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-preview_1600.66597b6a.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-scan.e9a07125.jpg";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-slack-white.29629a95.png";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-ui.41f5b12f.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-wsu-library-index-js-61723f8e9bb76f2a8225.js